"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HashFunctionCreator = void 0;
const HashingType_1 = require("./HashingType");
const md5_1 = require("./md5");
const sha1_1 = require("./sha1");
const sha256_1 = require("./sha256");
const keccak256_1 = require("./keccak256");
const keccak512_1 = require("./keccak512");
const sha3_256_1 = require("./sha3_256");
const sha3_512_1 = require("./sha3_512");
class HashFunctionCreator {
    static create(type) {
        switch (type) {
            case HashingType_1.HashingType.Type.md5: return new md5_1.MD5();
            case HashingType_1.HashingType.Type.sha1: return new sha1_1.SHA1();
            case HashingType_1.HashingType.Type.sha256: return new sha256_1.SHA256();
            case HashingType_1.HashingType.Type.keccak256: return new keccak256_1.KECCAK256();
            case HashingType_1.HashingType.Type.keccak512: return new keccak512_1.KECCAK512();
            case HashingType_1.HashingType.Type.sha3_256: return new sha3_256_1.SHA3_256();
            case HashingType_1.HashingType.Type.sha3_512: return new sha3_512_1.SHA3_512();
            default: throw Error('hashing type unmatched');
        }
    }
    static createWithTypeStr(typeStr) {
        const hashType = HashingType_1.HashingType.hashTypeStrToType(typeStr);
        return HashFunctionCreator.create(hashType);
    }
}
exports.HashFunctionCreator = HashFunctionCreator;
//# sourceMappingURL=HashFunctionCreator.js.map